import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NotFound from "@/pages/NotFound";

// Crew Captain vanity links: yachtrockdetroit.com/TeddySchoenith -> that
// buyer's personal OnTourHQ affiliate link (crew-captain referral promo,
// July 2026). Slugs are matched case-insensitively with punctuation
// stripped, so /TeddySchoenith, /teddyschoenith and /Teddy-Schoenith all
// resolve. Unknown names fall through to the normal 404. The map lives in
// src/data/crewLinks.json (generated from the SlickText master CSV — do not
// hand-edit; regenerate when new captains are added).

const normalize = (s: string) => s.toLowerCase().replace(/[^a-z0-9]/g, "");

const Splash = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0B1622",
      color: "#f7b41c",
      fontFamily: "system-ui, sans-serif",
      fontSize: "1.15rem",
      letterSpacing: "0.02em",
    }}
  >
    Setting sail… ⚓
  </div>
);

const CrewRedirect = () => {
  const { slug } = useParams();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    import("@/data/crewLinks.json").then((mod) => {
      if (cancelled) return;
      const links = mod.default as Record<string, string>;
      const url = links[normalize(slug || "")];
      if (url) {
        window.location.replace(url);
      } else {
        setNotFound(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return notFound ? <NotFound /> : <Splash />;
};

export default CrewRedirect;
